import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { connect } from "react-redux";
import { get } from "lodash";
import styles from "./index.scss";

class Layout extends Component {
	constructor(props) {
		super(props);
		this.scrollRef = React.createRef();
		this.state = {
			width: window.innerWidth
		};
	}
	componentDidMount() {
		window.addEventListener("resize", this.handleWindowSizeChange);
		window.addEventListener("scrollToTop", this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleWindowSizeChange);
		window.removeEventListener("scrollToTop", this.handleScroll);
	}

	handleWindowSizeChange = () => {
		this.setState({ width: window.innerWidth });
	};

	handleScroll = () => {
		this.scrollRef.current.scrollTo(0, 0);
	};

	render() {
		const { common } = this.props;
		// Layout ClassNames
		const _className = cx(common.layoutClassName, styles.rootContainer);
		const _contentClassName = cx(
			common.contentClassName,
			styles.contentClassName,
			{
				[styles.secondaryHeaderActive]: get(
					common,
					"secondaryHeader.isVisible",
					false
				)
			}
		);

		return (
			<div className={_className}>
				<div className={styles.mainContainer}>
					<div ref={this.scrollRef} className={_contentClassName}>
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

Layout.propTypes = {
	children: PropTypes.node,
	common: PropTypes.object
};

function mapStateToProps(state, props) {
	return {
		common: state.common,
		children: props.children
	};
}

function mapDispatchToProps() {
	return {};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Layout);
